export default __webpack_public_path__ + "static/media/companymainimage.3246d721.jpg";